import React, { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReactToPrint from "react-to-print";
import ComponentToPrint from "@/pages/Auctions/HtmlToPrint/CatalogPrint";
import { hideProgressSpinner, showProgressSpinner } from '@/lib/utils/ProgressSpinnerService';
import { handleCatalogueDownload } from '@/pages/Auctions/store/Auctions';
import ns from '@/lib/utils/NotificationService';

interface Props {
    /*loading: boolean*/
}

const HtmlPrint: React.FC<Props> = props => {

    React.useEffect(() => {
        window.scroll({ top: 0, left: 0, behavior: 'auto' })
    }, []);

    React.useEffect(() => {
        showProgressSpinner({ description: 'Generating Catalog...' });
    }, [])

    const componentLoaded = () => {
        hideProgressSpinner();
    }

    const componentRef = useRef<HTMLDivElement>(null)

    const { auctionId }: any = useParams();
    const [downloading, setDownloading] = useState(false);

    // Downloads the catalogue as a PDF file made on the server (no print dialog).
    const handleDownload = () => {
        setDownloading(true);
        handleCatalogueDownload(auctionId, (res) => {
            setDownloading(false);
            if (!res?.success || !res.response?.data) ns.error('', 'The catalogue could not be downloaded. Please try again.');
        });
    }

    return (
        <div className="pb-cat-page">
            <div className="pb-cat-toolbar">
                <ReactToPrint
                    trigger={() => <button type="button" id="printButton" className="pb-btn pb-btn-outline">Print</button>}
                    content={() => componentRef.current}
                />
                <button type="button" className="pb-btn pb-btn-primary" onClick={handleDownload} disabled={downloading}>
                    {downloading ? "Preparing PDF..." : "Download PDF"}
                </button>
            </div>
            <div ref={componentRef}>
                <ComponentToPrint componentLoaded={componentLoaded} />
            </div>
        </div>
    )
}


export default HtmlPrint;